import { render, staticRenderFns } from "./LoanAnalysis.vue?vue&type=template&id=486dc3d0&scoped=true"
import script from "./LoanAnalysis.vue?vue&type=script&lang=js"
export * from "./LoanAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486dc3d0",
  null
  
)

export default component.exports